export default {
  primary: "#0088E3",
  primaryLighter: "#0092F3",
  secondary: "#E9F6FF",
  positive: "#06B900",
  negative: "#F12D2D",
  accent: "#0067AC",
  header: "#000000",
  mainText: "#000000",
  subText: "#AFAFAF",
  descriptionText: "#A8A8A8",
  background: "#F3FAFF",
  backgroundSection: "#FFFFFF",
  tooltip: "#22AAF4",
  tooltip2: "#ECF3FF",
  tooltip2Text: "#4B82EA",
  sectionShadow: "#C1E4FF8F",
  sectionLine: "#0088E355",
  sectionShadowM: "#ccc",
  positivePlus: "#dcfedb",
  positiveBar: "#3fa457",
  negativePlus: "#feecec",
  negativeBar: "#de3934",
  averageBar: "#dbf0ff",
  white: "#fff",
  black: "#000",
  menuText: "#584F4F",
  trendingBlank: "#C1E4FF00",
  trendingFull: "#C1E4FF",
  line: "#DEDEDE",
  inputBorder: "#dddddd",
};
